import React, { forwardRef, useContext } from 'react';
import { StatusIndicatorContext } from './StatusIndicator';
import styled from './styles';

export interface StatusIndicatorTextProps extends React.ComponentPropsWithRef<'div'> {
  /** Content of StatusIndicatorText component. */
  children?: React.ReactNode | string | number;
}

/**
 * StatusIndicatorText component.
 * Any other props than `children` props will be provided to the root element.
 * To get the ref of the outermost element use `ref` prop. [Read React useRef hook documentation](https://reactjs.org/docs/hooks-reference).
 */

const StatusIndicatorText = forwardRef<HTMLElement, StatusIndicatorTextProps>((props: StatusIndicatorTextProps, ref) => {
  const { children, ...otherProps } = props;
  const { $theme } = useContext(StatusIndicatorContext);

  return (
    <styled.StatusIndicatorText ref={ref} $theme={$theme} {...otherProps}>
      {children}
    </styled.StatusIndicatorText>
  );
});
StatusIndicatorText.displayName = 'StatusIndicatorText';

StatusIndicatorText.defaultProps = {
  children: ''
};

export default StatusIndicatorText;
